import { combineEpics } from "redux-observable";
import { epicCollectLeagueInfo } from "./epics/epicCollectLeagueInfo";
import { epicCoopLeagueInfo } from "./epics/epicCoopLeagueInfo";
import { epicPlayerLeagueInfo } from "./epics/epicPlayerLeagueInfo";
export var epicLeagueInfo = combineEpics(epicCoopLeagueInfo, epicPlayerLeagueInfo, epicCollectLeagueInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/league/epicLeagueInfo.ts
// module id = 1910
// module chunks = 3